export interface Poem {
  id: string;
  name: string;
  source?: string;
}

export interface Poet {
  id: string;
  name: string;
  poems: Poem[];
  source?: string;
  wiki?: string;
  country?: string;
}

export const getWiki = (poet: Poet | undefined): string | null => {
  if (!poet) return null;
  // wiki: null means explicitly disabled; wiki: undefined means not set (use name)
  if (poet.wiki === null) return null;
  return poet.wiki ? poet.wiki : poet.name.replaceAll(' ', '_');
}

export interface Catalog {
  id: string;
  name: string;
  poets: Poet[];
  group?: 'country' | string;
  type?: string;
  source?: string;
}

export interface CatalogData {
  catalogs: Catalog[];
}

export interface RecentPoem {
  poemId: string;
  poemName: string;
  poetName: string;
  catalogId: string;
  timestamp: number;
}

